"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames"));

require("./_elevated-container.scss");

function ElevatedContainer(a) {
  var b = a.children,
      c = a.rounded,
      d = a.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("elevated-container".concat(c ? "--rounded" : ""), d)
  }, b);
}

var _default = (0, _react.memo)(ElevatedContainer);

exports["default"] = _default;